import { WorksheetsEnvironment } from 'printableWorksheets';
import React, { useEffect, useMemo, useState } from 'react'
import PrintableWorksheetsEvents from './events';
import { PRINTABLE_WORKSHEET_SCREENS, usePrintableWorksheetsState } from './state';
import DownloadedScreen from './components/views/DownloadedScreen';
import SavedScreen from './components/views/SavedScreen';
import SearchScreen from './components/views/SearchScreen';
import { useAppMediaProvider } from '../baseStyles/AppMediaProvider';
import Printables from './components/views/Printables';
import './styles.scss';
import { hasSignedUpFromWs, isFlutterUser, isSignedUpFromWsDetail } from 'apps/teacher/config/common';
import WSPreview from './components/worksheetsView/wsPreview';
import BaseUrls from 'apps/teacher/config/baseUrls';

declare let window: any;

const PrintableWorksheetsView = () => {
  
  const { activeGrade, worksheetsEnvironment, onboardingGrade, activeScreen, envProps } = usePrintableWorksheetsState();
  const { currentDevice, isMobile, isDesktop } = useAppMediaProvider();
  const [showWorksheetPreview, setShowWorksheetPreview] = useState(true);
  const [wsDetailsViaOnboarding, setWsDetailsViaOnboarding] = useState(null);
  
  useEffect(() => {
    if(hasSignedUpFromWs() && isSignedUpFromWsDetail() && isDesktop) {
      localStorage.setItem('wsPreviewShownViaOnboarding', 'true');

      const schoolUiHost = isFlutterUser() ? window.parent.parent.SCHOOL_UI_ASSET_HOST : window.SCHOOL_UI_ASSET_HOST;
      const ws_details = JSON.parse(localStorage.getItem('ws_details'));
      const fromWsList = localStorage.getItem("clickedWsFromListPage");
      const signupPageUrl = fromWsList ? localStorage.getItem("wsLinkUrl") : sessionStorage.getItem('signup_page_url') || '';
      const imageUrl = BaseUrls.cms_image_asset_url + signupPageUrl + '.jpeg';      
      const gradesAndStandard = ws_details.ws_grade_tags;
      const subject = ws_details.ws_subject_tag;
      const topics = ws_details.ws_topic_tags;
      const pdf_folder = `https://${schoolUiHost.includes("staging") ? "f2" : "www"}.splashlearn.com/worksheet_uploads/pdf/`
      const obj = {
        id: ws_details.ws_id,
        title: ws_details.ws_title,
        description: ws_details.ws_description,
        image_url: imageUrl,
        grades: gradesAndStandard,
        subject_and_topics: [subject, ...topics],
        pdf_url: pdf_folder + signupPageUrl + '.pdf',
        code: ws_details.ws_code
      }
      setWsDetailsViaOnboarding(obj);

      if(window.parent.triggerIsFlutterHeaderClickDisabled) {
        window.parent.triggerIsFlutterHeaderClickDisabled();
      }
    }
}, [])

  useEffect(()=> {
    if(worksheetsEnvironment) {
      fireMountEvent();
      if(worksheetsEnvironment === WorksheetsEnvironment.STUDENT_DASHBOARD && isMobile){
        document.body.style.margin = "0px";
        document.body.style.height = "100%";
      }
    }
  }, [worksheetsEnvironment])
  
  const fireMountEvent = () => {
    switch(worksheetsEnvironment){
      case WorksheetsEnvironment.TEACHER_DASHBOARD: {
        const props = {
          worksheetGrade: activeGrade
        }
        PrintableWorksheetsEvents.clickedWorksheetTab(props);
      }
        break;
      case WorksheetsEnvironment.STUDENT_DASHBOARD: {
        const props = {
          dashboardVersion: envProps?.params?.settings?.tileDashboardVersion,
          tabCode: envProps?.activeHeaderTabId,
          grade: onboardingGrade,
          from: '',
          worksheetCode: '',
        }
        PrintableWorksheetsEvents.viewedTiledDashboard(props);
      }
    }
  };

  const activeScreenToBeDisplayed: any = useMemo(() => {
    switch(activeScreen){
      case PRINTABLE_WORKSHEET_SCREENS.DEFAULT:
        return <Printables />;
      case PRINTABLE_WORKSHEET_SCREENS.SAVED:
        return <SavedScreen />
      case PRINTABLE_WORKSHEET_SCREENS.DOWNLOADED:
        return <DownloadedScreen />
      case PRINTABLE_WORKSHEET_SCREENS.SEARCH:
        return <SearchScreen />
      default: 
        return <Printables />
    }
  }, [activeScreen]);

  return (
    <>
      {
        showWorksheetPreview && isSignedUpFromWsDetail() && isDesktop &&
        <WSPreview worksheetDetails={wsDetailsViaOnboarding} setShowWorksheetPreview={setShowWorksheetPreview} showWorksheetPreview={showWorksheetPreview} />
      }
      <div className={`printable-worksheets device-${currentDevice} w-env-${worksheetsEnvironment}`} 
        ref={(ref) => {
          if(ref && !isMobile) {
            const elementDetails = ref.getBoundingClientRect();
            ref.style.height = `calc(100vh - ${elementDetails.top + 20}px)`;
          }
        }}
      >
        {activeScreenToBeDisplayed}
      </div>
    </>
  )
}

export default PrintableWorksheetsView  